import useSWR from 'swr';
import type { AccountTransaction } from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';

/** Poll the exact parent being signed, including children hidden from the queue until initiation finishes. */
export function useTransactionById(id: string | null, refreshInterval = 0) {
  const { data, mutate } = useSWR(
    id ? `transactions/${encodeURIComponent(id)}` : null,
    (url) => denApi.get<{ data: AccountTransaction }, void>(url),
    { refreshInterval, revalidateOnFocus: false }
  );
  return { transaction: data?.data, refetch: mutate };
}
